<div class="container-fluid ad-manager-page">
    <div class="page-header">
        <div>
            <h1>Ad Manager</h1>
        </div>
    </div>

    <div class="section-switcher" role="tablist" aria-label="Ad manager sections">
        <button type="button" class="section-switcher-item" [class.active]="activeSection === 'media'"
            [attr.aria-pressed]="activeSection === 'media'" (click)="setActiveSection('media')">
            <mat-icon>perm_media</mat-icon>
            <span>
                <strong>Media Library</strong>
                <small>Creative assets</small>
            </span>
        </button>

        <button type="button" class="section-switcher-item" [class.active]="activeSection === 'playlists'"
            [attr.aria-pressed]="activeSection === 'playlists'" (click)="setActiveSection('playlists')">
            <mat-icon>playlist_play</mat-icon>
            <span>
                <strong>Playlists</strong>
                <small>Build and edit</small>
            </span>
        </button>

        <button type="button" class="section-switcher-item" [class.active]="activeSection === 'campaign'"
            [attr.aria-pressed]="activeSection === 'campaign'" (click)="setActiveSection('campaign')">
            <mat-icon>dashboard_customize</mat-icon>
            <span>
                <strong>Campaign</strong>
                <small>Assign screens</small>
            </span>
        </button>
    </div>

    <div class="section-shell">
        @if (activeSection === 'media') {
        <section class="tab-section section-view">
            <div class="section-toolbar">
                <div>
                    <div class="section-kicker">Media Library</div>
                    <div class="section-title">Creative assets</div>
                    <div class="section-subtitle">Upload, review, and remove media used in playlists.</div>
                </div>

                <div class="section-toolbar-actions">
                    <input type="file" multiple (change)="uploadMedia($event)" hidden #fileInput>

                    <button mat-raised-button color="primary" (click)="fileInput.click()">
                        <mat-icon>upload</mat-icon>Upload Media
                    </button>
                </div>
            </div>

            <div class="card overflow-auto" appDynamicHeight [offset]="370" [minHeight]="200">
                <table mat-table [dataSource]="mediaList" class="modern-table media-table">

                    <ng-container matColumnDef="name">
                        <th mat-header-cell *matHeaderCellDef>Name</th>
                        <td mat-cell *matCellDef="let element">{{ element.name }}</td>
                    </ng-container>

                    <ng-container matColumnDef="type">
                        <th mat-header-cell *matHeaderCellDef>Type</th>
                        <td mat-cell *matCellDef="let element">{{ element.type }}</td>
                    </ng-container>

                    <ng-container matColumnDef="size">
                        <th mat-header-cell *matHeaderCellDef>Size</th>
                        <td mat-cell *matCellDef="let element">{{ element.size / 1024 | number:'1.0-2' }} KB</td>
                    </ng-container>

                    <ng-container matColumnDef="orientation">
                        <th mat-header-cell *matHeaderCellDef>Orientation</th>
                        <td mat-cell *matCellDef="let element">{{ element.orientation }}</td>
                    </ng-container>

                    <ng-container matColumnDef="created">
                        <th mat-header-cell *matHeaderCellDef>Created</th>
                        <td mat-cell *matCellDef="let element">{{ element.created | date }}</td>
                    </ng-container>

                    <ng-container matColumnDef="action">
                        <th mat-header-cell *matHeaderCellDef></th>
                        <td mat-cell *matCellDef="let element">
                            <button mat-icon-button (click)="deleteMedia(element)">
                                <mat-icon color="warn">delete</mat-icon>
                            </button>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedMediaColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedMediaColumns"></tr>
                </table>
            </div>
        </section>
        }

        @if (activeSection === 'playlists') {
        <section class="tab-section section-view">
            <div class="section-toolbar">
                <div>
                    <div class="section-kicker">Playlists</div>
                    <div class="section-title">Playlist library</div>
                    <div class="section-subtitle">Create and manage playlists before assigning them in campaigns.</div>
                </div>

                <div class="section-toolbar-actions">
                    <button mat-raised-button color="primary" (click)="openCreatePlaylist()">
                        <mat-icon>add</mat-icon>Create Playlist
                    </button>
                </div>
            </div>

            <div class="card overflow-auto" appDynamicHeight [offset]="370" [minHeight]="200">
                <table mat-table [dataSource]="playlistList" class="modern-table playlist-table">
                    <ng-container matColumnDef="name">
                        <th mat-header-cell *matHeaderCellDef>Playlist Name</th>
                        <td mat-cell *matCellDef="let element">{{ element.name }}</td>
                    </ng-container>

                    <ng-container matColumnDef="created">
                        <th mat-header-cell *matHeaderCellDef>Created</th>
                        <td mat-cell *matCellDef="let element">{{ element.created | date }}</td>
                    </ng-container>

                    <ng-container matColumnDef="action">
                        <th mat-header-cell *matHeaderCellDef>Actions</th>
                        <td mat-cell *matCellDef="let element; let i = index">
                            <button mat-icon-button color="primary" matTooltip="Edit playlist"
                                (click)="openEditPlaylist(element.id)">
                                <mat-icon>edit</mat-icon>
                            </button>

                            <button mat-icon-button color="warn" matTooltip="Delete playlist"
                                (click)="deletePlaylist(i)" [disabled]="commonService.showSpinner">
                                <mat-icon>delete</mat-icon>
                            </button>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedPlaylistColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedPlaylistColumns"></tr>
                </table>
            </div>
        </section>
        }

        @if (activeSection === 'campaign') {
        <section class="tab-section campaign-section section-view">
            <div class="campaign-hero">
                <div>
                    <div class="section-kicker">Campaign Builder</div>
                    <div class="section-title">Assign one playlist to the right screens without repeating the same grid.
                    </div>
                    <div class="section-subtitle">
                        Pick a playlist on the left, review its assigned screens, and move screens from a single
                        catalog.
                    </div>
                </div>

                <button mat-raised-button color="primary" class="save-campaign-button" (click)="saveCampaign()">
                    <mat-icon>save</mat-icon>Save Campaign
                </button>
            </div>

            <div class="campaign-workspace">
                <aside class="playlist-rail" appDynamicHeight [offset]="360" [minHeight]="200">
                    <div class="rail-header">
                        <div>
                            <div class="section-kicker">Playlists</div>
                            <div class="rail-title">Select one playlist</div>
                        </div>
                        <span class="rail-count">{{ playlists.length }}</span>
                    </div>

                    <div class="playlist-rail-list">
                        @for (playlist of playlists; track playlist.playlist_id) {
                        <button type="button" class="playlist-card"
                            [class.active]="selectedPlaylistId === playlist.playlist_id"
                            (click)="selectPlaylist(playlist)">
                            <div class="playlist-card-head">
                                <div>
                                    <div class="playlist-card-title">{{ playlist.playlist_name }}</div>
                                    <div class="playlist-card-meta">Created {{ playlist.created | date }}</div>
                                </div>
                                <span class="playlist-count">{{ getPlaylistScreenCount(playlist.playlist_id) }}</span>
                            </div>

                            <div class="playlist-card-foot">
                                <span class="playlist-chip">
                                    {{ selectedPlaylistId === playlist.playlist_id ? 'Focused' : 'Tap to edit' }}
                                </span>
                            </div>
                        </button>
                        }
                    </div>
                </aside>

                <section class="campaign-panel" appDynamicHeight [offset]="360" [minHeight]="200">
                    @if (selectedPlaylist) {
                    <div class="workspace-header">
                        <div>
                            <div class="section-kicker">Focused playlist</div>
                            <div class="workspace-title">{{ selectedPlaylist.playlist_name }}</div>
                            <div class="workspace-subtitle">
                                {{ getPlaylistScreenCount(selectedPlaylist.playlist_id) }} screen(s) assigned right now.
                            </div>
                        </div>

                        <div class="workspace-actions">

                            <div class="search-container campaign-search">
                                <mat-icon class="search-icon">search</mat-icon>
                                <input type="text" class="search-input" placeholder="Search screen or business"
                                    (input)="onCampaignSearch($event)" />
                            </div>

                            <button mat-stroked-button color="primary" (click)="selectAllScreens(selectedPlaylist)">
                                <mat-icon>select_all</mat-icon>Select All
                            </button>
                            <button mat-stroked-button color="warn" (click)="deselectAllScreens(selectedPlaylist)">
                                <mat-icon>deselect_all</mat-icon>Clear
                            </button>
                        </div>
                    </div>

                    <div class="campaign-panel-body">

                        <div class="selected-strip">
                            <div class="selected-strip-header">
                                <span class="section-kicker">Assigned to this playlist</span>
                                <span class="selected-strip-count">{{
                                    getPlaylistScreenCount(selectedPlaylist.playlist_id) }}</span>
                            </div>

                            @if (getPlaylistScreens(selectedPlaylist.playlist_id).length) {
                            <div class="selected-chip-grid">
                                @for (screen of getPlaylistScreens(selectedPlaylist.playlist_id); track screen.id) {
                                <span class="selected-chip">{{ screen.name }}</span>
                                }
                            </div>
                            }
                            @else {
                            <div class="empty-inline">
                                No screens assigned yet. Start selecting from the catalog below.
                            </div>
                            }
                        </div>

                        <div class="screen-catalog">
                            @for (group of visibleScreenGroups; track group.businessName + '-' + group.businessId) {
                            <section class="business-section">
                                <div class="business-header">
                                    <div>
                                        <div class="business-title">{{ group.businessName }}</div>
                                        <div class="business-subtitle">{{ group.screens.length }} screen(s)</div>
                                    </div>
                                    <div class="business-status">
                                        {{ getGroupAssignedCount(group) }} assigned to this playlist
                                    </div>
                                </div>

                                <div class="screen-grid">
                                    @for (screen of group.screens; track screen.screen_id) {
                                    <label class="screen-card"
                                        [class.screen-card-selected]="isScreenAssigned(screen.screen_id, selectedPlaylist.playlist_id)"
                                        [class.screen-card-owned]="getScreenAssignmentState(screen.screen_id, selectedPlaylist.playlist_id) === 'owned'">
                                        <input type="checkbox"
                                            [checked]="isScreenAssigned(screen.screen_id, selectedPlaylist.playlist_id)"
                                            (change)="toggleScreen(screen, selectedPlaylist, $event)" />

                                        <div class="screen-card-copy">
                                            <div class="screen-card-title">{{ screen.screen_name }}</div>
                                            <div class="screen-card-meta">ID {{ screen.screen_id }}</div>
                                        </div>

                                        <span class="screen-state"
                                            [ngClass]="getScreenAssignmentState(screen.screen_id, selectedPlaylist.playlist_id)">
                                            {{ getScreenAssignmentLabel(screen.screen_id, selectedPlaylist.playlist_id)
                                            }}
                                        </span>
                                    </label>
                                    }
                                </div>
                            </section>
                            }

                            @if (visibleScreenGroups.length === 0) {
                            <div class="empty-inline">No screens match the current search.</div>
                            }
                        </div>
                    </div>
                    }
                    @else {
                    <div class="empty-campaign-state">Select a playlist to start assigning screens.</div>
                    }
                </section>
            </div>
        </section>
        }
    </div>
</div>

<ng-template #confirmDialog let-data>
    <h2 mat-dialog-title class="d-flex align-items-center gap-2 text-danger mt-4">
        <mat-icon color="warn">warning</mat-icon>
        {{ data.title }}
    </h2>

    <mat-dialog-content>
        <p class="mb-2 ms-2">{{ data.message }}</p>
    </mat-dialog-content>

    <mat-dialog-actions align="end">
        <button mat-button (click)="dialog.closeAll()">
            <mat-icon>close</mat-icon>
            Cancel
        </button>

        <button mat-flat-button color="warn" (click)="data.onConfirm()">
            <mat-icon>delete</mat-icon>
            Confirm
        </button>
    </mat-dialog-actions>
</ng-template>